import { Box } from '@mui/material';
import { memo } from 'react';

function ProjectStateBox({ projectState }: { projectState: string }): JSX.Element {
  const stateBackground: { [key: string]: string } = {
    proceeding: 'mind.custom.proceeding',
    complete: 'mind.custom.completed',
    pending: 'mind.custom.pending',
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: stateBackground[projectState] ?? 'mind.custom.tableHead',
        color: 'mind.custom.white',
        height: 24,
        typography: 's12w400',
        borderRadius: '4px',
        minWidth: 93,
        textTransform: 'capitalize',
      }}
    >
      {projectState ?? '-'}
    </Box>
  );
}

export default memo(ProjectStateBox);
